import { Component, OnDestroy, OnInit } from '@angular/core';
import { TabDirective } from 'ngx-bootstrap/tabs';
import { ActivatedRoute } from '@angular/router';

import { MainService } from 'src/app/services/main.service';
import { AutoUnsubscribeService } from 'src/app/services/auto-unsubscribe.service';
import { AppSyncWebSocketService } from 'src/app/appsyncwebsocketservice.service';
import { aqualinkEdge, featureIconMap } from 'src/app/constants/app-constants';
import { takeUntil } from 'rxjs';
import { BannerService } from 'src/app/services/banner.service';
import { BannerType } from 'src/app/interface-model/app-interface-model';
@Component({
    selector: 'app-thermostat-feature-profile',
    templateUrl: './thermostat-feature-profile.component.html',
    styleUrls: ['./thermostat-feature-profile.component.css'],
    standalone: false
})
export class ThermostatFeatureProfileComponent extends AutoUnsubscribeService implements OnInit, OnDestroy {

  thermostatId: any;
  controllerId: any;
  thermostatFeatureDetailsLoadComplete: boolean = false;
  thermostatFeatureDetails: any;
  value: any;

  thermostatFeatureStatus: any;
  thermostatFeatureStatusTab: any;
  thermostatFeatureSourcePriorities: any;
  controllerProfile: any;
  thermostatFeatureName: any;
  asyncEvent: { [key: string]: any[] } = {};
  thermostatExecutionState: any;
 
  thermostatIconMap = featureIconMap;
  isControllerDisconnected: boolean = false;
  disconnectedModelName: string = aqualinkEdge;
  thermostatIconSrc = 'assets/img/heat.svg';
  lastThermostat:any;


  constructor(public mainService: MainService, public activatedRoute: ActivatedRoute, private appSyncWebSocketService: AppSyncWebSocketService,private bannerService:BannerService) {
    super();
    this.setComponentName(this.constructor.name);
  }

  ngOnInit(): void {
    this.thermostatId = this.activatedRoute.snapshot.paramMap.get('id');

    this.thermostatFeatureName = localStorage.getItem('selectedFeatureName');
    this.controllerId = localStorage.getItem('controllerIDForSchedule');

    this.getThermostatFeatureDetails();
  }

  updateFeatureIconSrc(mode: string): void {
    if(mode){
      const iconKey = mode.toLowerCase();
      if(this.thermostatIconMap[iconKey]){
        this.thermostatIconSrc = this.thermostatIconMap[iconKey];
      }
    }
  }

  activationReasonMap: { [key: string]: string } = {
    invalid: '-',
    scheduled: 'Schedule',
    freezeProtect: 'Freeze Protection',
    freezeProtectHighPriority: 'Freeze Protection',
    onDemand: 'Manual',
    'onDemand-timed': 'Manual',
    serviceOnDemand: 'Manual',
    internal: '-',
    waterQualityManagerBoost: 'Manual'
  };

  onSelect(data: TabDirective): void {
    this.value = data.heading();
    this.thermostatId = this.activatedRoute.snapshot.paramMap.get('id');
  }

  getThermostatFeatureDetails() {
    console.log('Called getDetailedFeatureEquipment()');

    this.mainService.getDetailedFeatureEquipment(this.thermostatId, this.controllerId,true).subscribe((data: any) => {
      if (data) {
       
        this.updateFeatureIconSrc(data.status.mode); // Update icon when iconId is available
        this.thermostatFeatureDetailsLoadComplete = true;
        this.thermostatFeatureDetails = data;
        this.thermostatFeatureStatus = data.thermostatStatus;
        this.thermostatFeatureStatusTab = data.status;
        if(this.thermostatFeatureStatusTab.mode == 'auto') {
          this.thermostatFeatureStatusTab.autoSetPoint =  this.thermostatFeatureStatus.equipmentOperationStatus.replace('Auto ', '').replaceAll('F', '').trim();
        }
        this.thermostatFeatureSourcePriorities = data.sourcePriorityEquipment;
        this.websocketConnection();

      }
    });

  }

  websocketConnection() {
    this.appSyncWebSocketService.connectWebSocket(this.controllerId);
    this.appSyncWebSocketService.getStatusEvent().subscribe(data => {
      if (data) {
        const flattenedPayload = { ...(typeof data.payload === 'object' ? data.payload : {}), context: data.context, dataModelVersion: data.dataModelVersion, ventType: data.eventType };
       
        if (!this.asyncEvent![data.context]) {
          this.asyncEvent[data.context] = [];
        }

        this.asyncEvent[data.context].push(flattenedPayload);

        const realTimeForFeaturesEquipments = this.asyncEvent?.['equipment'];
        this.mainService.realTimeForFeaturesEquipments.next(realTimeForFeaturesEquipments);

        const realTimeThermostatDataForFeatures = this.asyncEvent?.['thermostats'];
        this.mainService.updateRealTimeDataForThermostats.next(realTimeThermostatDataForFeatures);

        // Find the last thermostat where heatOutcomeList includes the featureId
        this.lastThermostat = Array.isArray(realTimeThermostatDataForFeatures)
          ? [...realTimeThermostatDataForFeatures]
              .reverse()
              .find(item =>
                this.thermostatId === item.thermostatId
              )
          : null;

        if (this.lastThermostat) {
          this.thermostatExecutionState = this.lastThermostat?.status?.executionState;
          this.updateFeatureIconSrc(this.lastThermostat.thermostatMode); // Update icon when mode changes
        }

        const cloud = this.asyncEvent?.['cloud'];
        const cloudData = cloud && cloud.length > 0 ? cloud[cloud.length - 1] : null;
        if (cloudData) {
          this.isControllerDisconnected = cloudData.status === 'disconnected';
          this.bannerService.handleBanner({
            id: 'disconnect',
            type: BannerType.Danger,
            iconSrc: 'assets/img/redWarning.svg',
            translationKey: 'lang.is_disconnected',
            data: { disconnectedModelName: this.disconnectedModelName },
            isActive: this.isControllerDisconnected,
          });
        }
      }
    });
    this.appSyncWebSocketService.getTelemetryData()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.mainService.telemetryDataForConnectedSystems.next(data);
      });
  }


  buildOperationStatus(
    thermostat: any,
    mode: string,
  ): string | undefined {
    if (!thermostat?.setpoints) {
      return undefined;
    }
  
    if (mode === 'heat') {
      const temp = this.scaledCelsiusToFahrenheit(
        thermostat?.setpoints?.heatSetpoint
      );
      return temp !== undefined ? `Heating to ${temp}°F` : undefined;
    }
  
    if (mode === 'chill') {
      const temp = this.scaledCelsiusToFahrenheit(
        thermostat?.setpoints?.chillSetpoint
      );
      return temp !== undefined ? `Chilling to ${temp}°F` : undefined;
    }
  
    if (mode === 'auto') {
      const chill = this.scaledCelsiusToFahrenheit(
        thermostat?.setpoints?.autoChillSetpoint
      );
      const heat = this.scaledCelsiusToFahrenheit(
        thermostat?.setpoints?.autoHeatSetpoint
      );
      return chill !== undefined && heat !== undefined
        ? `Auto ${chill}°F - ${heat}°F`
        : undefined;
    }
  
    // 👇 ensures ALL paths return
    return undefined;
  }
  

  scaledCelsiusToFahrenheit(scaledCelsius: number): number {
    const celsius = scaledCelsius / 10;              // 267 → 26.7
    const fahrenheit = (celsius * 9 / 5) + 32;  // → 80.06
    return Math.round(fahrenheit); 
  }

  navigateBack(): void {
    this.mainService.goBack();
  }

  getThermostatState(): string {
    if (this.thermostatExecutionState) {
      console.log('thermostatExecutionState in getThermostatState():', this.thermostatExecutionState);
      return this.thermostatExecutionState?.toLowerCase() === "stopped" ? 'Off' : 'On';
    }

    return this.thermostatFeatureStatus?.state || "";
  }

  getThermostatOperationStatus(): string {
    if(this.lastThermostat) {
      const operationStatus = this.buildOperationStatus(this.lastThermostat, this.lastThermostat?.thermostatMode);
      return operationStatus || "";
    }
    return this.thermostatFeatureStatus?.equipmentOperationStatus || "";
  }

  getThermostatActivationReason(): string {
    if(this.lastThermostat) {
      return this.lastThermostat?.status?.triggerType || "-";
    }
    return this.thermostatFeatureStatus?.activationReason || "-";
  }
  
  getThermostatSpaceName(): string {
    return this.thermostatFeatureDetails?.spaces?.displayName || "";
  }

  override ngOnDestroy(): void {
    // Clear controllerProfile from local storage
    localStorage.removeItem('controllerProfile');
    localStorage.removeItem('controllerIDForSchedule');

    super.ngOnDestroy?.();
  }

   getWaterFeatureIconSrc(iconId: string): string {
    return `assets/img/${iconId}.svg`;
  }
}
